let login = {
    title: {
        a: 'MyBookOne',
        b: 'SIS Platform Management System',
    },
    loginName: "Login",
    password: "Password",
    submit: "Submit"
}

export default {
    login
}